import xamatron from "xamatron";
import {createApp} from "vue";
import {createMemoryHistory, createRouter} from "vue-router";
import store from "store";
import routes from "views";
import _i18n from "i18n";
import "@style/main.less";

import KkRoot from "@/components/KkRoot.vue";
import KkSpinner from "@/components/KkSpinner.vue";
import EventStatisticsView from "@/views/EventStatisticsView.vue";
import EventParticipantTopList from "@/components/EventParticipantTopList.vue";
import KkGenericPopup from "@/components/KkGenericPopup.vue";
import UserStatisticsView from "@/views/UserStatisticsView.vue";
import TopEventParticipantsView from "@/views/TopEventParticipantsView.vue";
import OrganizationStatisticsView from "@/views/OrganizationStatisticsView.vue";
import AllStatisticsView from "@/views/AllStatisticsView.vue";
import SponsorListItem from "@/components/SponsorListItem.vue";
import KkPopup from "@/components/KkPopup.vue";
import {createI18n} from "vue-i18n";

const app = createApp(KkRoot);

const router = createRouter({
    history: createMemoryHistory(),
    linkActiveClass: "active",
    routes,
})

const i18n = createI18n({
    ..._i18n,
    locale: "fi",
    fallbackLocale: "fi",
});

app.use(router);
app.use(i18n)

app.config.globalProperties.$popup = (title: string, description: string) => {
    store.popup.title = title;
    store.popup.description = description;
    store.popup.visible = true;
};

app.config.globalProperties.$getSiteUrl = (path: string) => {
    return `https://kunniakierros.fi/${i18n.global.locale}/${path}`;
}

app.config.globalProperties.$clearHistory = async () => {
    await router.replace({ ...router.currentRoute.value })
}

app.component("kk-spinner", KkSpinner);
app.component("kk-event-statistics", EventStatisticsView);
app.component("kk-event-participant-top-list", EventParticipantTopList);
app.component("kk-generic-popup", KkGenericPopup);
app.component("kk-user-statistics", UserStatisticsView);
app.component("kk-top-event-participants", TopEventParticipantsView);
app.component("kk-organization-statistics", OrganizationStatisticsView);
app.component("kk-all-statistics", AllStatisticsView);
app.component("kk-sponsor-list-item", SponsorListItem);
app.component("kk-popup", KkPopup);

xamatron.ready(() => {
    app.mount("#app");
});
